/**
 * API Configuration
 * Determines which server the frontend connects to
 */

const isDevelopment = import.meta?.env?.DEV || (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV);
const isProduction = import.meta?.env?.PROD || 
                    (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.PROD) ||
                    (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1');

// Server URL Configuration
// Development: Your local server
// Production: Your computer's public IP or domain
// 
// To find your public IP: https://whatismyipaddress.com/
// Update this when your IP changes (if using dynamic IP)
const SERVER_HOST = isDevelopment
  ? 'localhost'
  : '136.33.71.175';  // Your public IP address

const SERVER_PORT = 3000;

export const API_URL = isDevelopment
  ? `http://${SERVER_HOST}:${SERVER_PORT}`
  : `http://${SERVER_HOST}:${SERVER_PORT}`;

export const WS_URL = isDevelopment
  ? `ws://${SERVER_HOST}:${SERVER_PORT}`
  : `ws://${SERVER_HOST}:${SERVER_PORT}`;

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_URL}/api/v1/auth/login`,
    REGISTER: `${API_URL}/api/v1/auth/register`,
    VERIFY: `${API_URL}/api/v1/auth/verify`
  },
  USER: {
    PROFILE: `${API_URL}/api/v1/user/profile`,
    CITIES: `${API_URL}/api/v1/user/cities`
  },
  CITY: {
    GET: (cityId) => `${API_URL}/api/v1/cities/${cityId}`,
    UPDATE: (cityId) => `${API_URL}/api/v1/cities/${cityId}`,
    RESOURCES: (cityId) => `${API_URL}/api/v1/cities/${cityId}/resources`
  },
  WORLD: {
    LIST: `${API_URL}/api/v1/world`,
    GET: (worldId) => `${API_URL}/api/v1/world/${worldId}`,
    REGIONS: (worldId) => `${API_URL}/api/v1/world/${worldId}/regions`
  }
};

// WebSocket Events
export const WS_EVENTS = {
  // Client → Server
  CITY_JOIN: 'city:join',
  CITY_LEAVE: 'city:leave',
  BUILDING_PLACE: 'building:place',
  BUILDING_REMOVE: 'building:remove',
  RESOURCES_REQUEST: 'resources:request',
  CONSTRUCTION_REQUEST: 'construction:request',
  PING: 'ping',
  
  // Server → Client
  CITY_STATE: 'city:state',
  BUILDING_PLACED: 'building:placed',
  BUILDING_REMOVED: 'building:removed',
  RESOURCES_UPDATE: 'resources:update',
  CONSTRUCTION_UPDATE: 'construction:update',
  CONSTRUCTION_COMPLETED: 'construction:completed',
  CITY_UPDATED: 'city:updated',
  PONG: 'pong',
  ERROR: 'error'
};

// Helper function to get auth token from localStorage
export function getAuthToken() {
  return localStorage.getItem('auth_token');
}

// Helper function to set auth token
export function setAuthToken(token) {
  localStorage.setItem('auth_token', token);
}

// Helper function to remove auth token
export function removeAuthToken() {
  localStorage.removeItem('auth_token');
}

// Helper function to get auth headers
export function getAuthHeaders() {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
}

